import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}))

/* Types */

export const ACTION_NEW__PROJECT = 'ACTION_NEW__PROJECT'

export const ACTION_SEARCH__PROJECT = 'ACTION_SEARCH__PROJECT'

export const ACTION_GET__PROJECT = 'ACTION_GET__PROJECT'

export const ACTION_DELETE__PROJECT = 'ACTION_DELETE__PROJECT'

export const ACTION_UPDATE__PROJECT = 'ACTION_UPDATE__PROJECT'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_NEW__PROJECT:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_SEARCH__PROJECT:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET__PROJECT:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_DELETE__PROJECT:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_UPDATE__PROJECT:
			return state.set('Response', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const addProject = (form) => {
	let data = Object.assign({}, form)
	data.preguntas = Utils.getListPropsOmit(data.preguntas, ['preguntaItem','valor', 'tmp', "id"])
	data.preguntas.forEach(p => {
		p.seccion = p.seccion.trim();
	})
	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/newProject',
			method: "POST",
			data: {...data},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_NEW__PROJECT, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchProject = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length == 0 ? 'api/searchProject' : 'api/searchParamProject',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH__PROJECT, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}

}

export const getProject = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getProject',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			if(response.data.preguntas){
				response.data.preguntas.forEach(p => {
					if(!p.seccion)
						p.seccion = "Preguntas generales"
				})
			}
			dispatch({ type: ACTION_GET__PROJECT, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getsProject = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))
		dispatch({ type: ACTION_GET__PROJECT, Obj: {} })

		return new ClientHttpRequest({
			service: 'api/getsProject',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch({ type: ACTION_SEARCH__PROJECT, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const deleteProject = () => {
	return (dispatch) => {
		return dispatch({ type: ACTION_DELETE__PROJECT, Obj: {code: '', message: ''} })
	}
}

export const updateProject = (form) => {

	let data = Object.assign({}, form)

	data.preguntas = Utils.getListPropsOmit(data.preguntas, ['preguntaItem','valor', 'tmp', 'custom', "id"])

	data.preguntas = Utils.unionArray(data.preguntas, data.projectRemove)

	return (dispatch) => {

		dispatch(isLoading(true))
		dispatch({ type: ACTION_GET__PROJECT, Obj: {} })

		return new ClientHttpRequest({
			service: 'api/updateProject',
			method: "POST",
			data: {...data},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE__PROJECT, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearProject = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET__PROJECT, Obj: {} })
		dispatch({ type: ACTION_SEARCH__PROJECT, Obj: []})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/Project/Project.js